const ADD_DIGIT = 'ADD_DIGIT';
const CHOOSE_OPERATION = 'CHOOSE_OPERATION';
const SET_BLOCKS = 'SET_BLOCKS';
const SET_DRAGGABLE_BLOCK = 'SET_DRAGGABLE_BLOCK';
const EVALUATE = 'EVALUATE';
const DRAG_END = 'DRAG_END';
const DRAG_START = 'DRAG_START';
const SET_DROPPABLE_SECTION = 'SET_DROPPABLE_SECTION';
const CHANGE_CONSTRUCTOR_MODE = 'CHANGE_CONSTRUCTOR_MODE';

export {
	ADD_DIGIT,
	CHOOSE_OPERATION,
	SET_BLOCKS,
	SET_DRAGGABLE_BLOCK,
	EVALUATE,
	DRAG_END,
	DRAG_START,
	SET_DROPPABLE_SECTION,
	CHANGE_CONSTRUCTOR_MODE,
};
